import jquery from 'jquery';
import $ from 'jquery';
import gsap from 'gsap';

import { hamburgers } from './hamburger-array';
import { btnFade } from './utils';

class Slideshow {
    constructor() {

        this.tlCloseB2 = new TimelineMax({ paused: true });
        this.tlCloseB = new TimelineMax({ paused: true });
        this.tlZoomImageClose = null;

        this.currentIndex = null;

    }

    init(currentIndex) {

        this.currentIndex = currentIndex;
        this.bindEvents();

    }

    bindEvents() {

        $('#next-slider-burger').off('click').on('click', () => {
            this.slideNext();
        });

        $('#prev-slider-burger').off('click').on('click', () => {
            this.slidePrev();
        });

    }

    openSlideshow() {

        TweenMax.to('.background-img-burger', 1, {
            width: '100vw',
            ease: Power3.easeInOut
        });

        this.tlZoomImageClose = new TimelineMax({ paused: true });

        this.tlZoomImageClose.to('#cont-close-single-img', 0.8, {
            bottom: 0,
            ease: Power3.easeInOut
        }).to('#vertical-line-img', 0.9, {
            height: '45px',
            ease: Power3.easeInOut
        }, 0.4)
        .to('.cont-mask-close-burger', 1, {
            top: 0,
            ease: Power3.easeInOut
        }, 0.4).to('.close-img-zoom', 1, {
            top: 0,
            ease: Power3.easeInOut
        }, 0.4).to('#prev-slider-burger', 1.2, {
            left: '-20px',
            ease: Back.easeOut.config(1.7),
            y: 0,
            onComplete: () => {
                $('#prev-slider-burger').hover(() => {
                    TweenMax.to('#prev-slider-burger', 0.4, { left: 0, ease: Power3.easeInOut });
                }, () => {
                    TweenMax.to('#prev-slider-burger', 0.4, { left: '-20px', ease: Power3.easeInOut });
                });
            }
        }, 0.6).to('#next-slider-burger', 1.2, {
            right: '-20px',
            ease: Back.easeOut.config(1.7),
            y: 0,
            onComplete: () => {
                $('#next-slider-burger').hover(() => {
                    TweenMax.to('#next-slider-burger', 0.4, {
                        right: 0,
                        ease: Power3.easeInOut
                    });
                }, () => {
                    TweenMax.to('#next-slider-burger', 0.4, {
                        right: '-20px',
                        ease: Power3.easeInOut
                    });
                });
            }
        }, 0.6);

        this.tlZoomImageClose.play();

    }

    slideNext() {

        $('#next-slider-burger').css('pointer-events', 'none');

        let $classeDaRimuovere = $('.img-darimuovere');
        let $immagineDaAppendere = $('<div class="img-burger-appesa img-burger-top img-darimuovere img-daanimare-right background-img-burger width-100"></div>');

        $('body').append( $immagineDaAppendere );

        TweenMax.to('.img-daanimare-right', 1.6, {
            left: 0,
            ease: Power3.easeInOut,
            onComplete: function () {
                $('.img-burger-appesa').toggleClass('img-daanimare-right img-animata-right');
            }
        });
        TweenMax.to($classeDaRimuovere, 1.2, {
            left: '-70vw',
            ease: Power3.easeInOut,
            delay: 0.2,
            onComplete: function () {
                $classeDaRimuovere.remove();
                $('#next-slider-burger').css('pointer-events', 'auto');
            }
        });

        let hamburger = hamburgers[this.currentIndex];
        hamburger.corrente++;
        if( hamburger.corrente > hamburger.immagini.length - 1 ){
            hamburger.corrente = 0;
            let urlImgLast = 'url' + '(' + hamburger.immagini[ hamburger.corrente ] + ')';
            $('.img-daanimare-right').css( 'background-image', urlImgLast);
        }
        let urlImgSel = 'url' + '(' + hamburger.immagini[ hamburger.corrente ] + ')';
        $('.img-daanimare-right').css( 'background-image', urlImgSel);

    }

    slidePrev() {

        $('#prev-slider-burger').css('pointer-events', 'none');

        let $classeDaRimuovere = $('.img-darimuovere');
        let $immagineDaAppendere = $('<div class="img-burger-appesa img-burger-top img-darimuovere img-daanimare-left background-img-burger width-100"></div>');

        $('body').append( $immagineDaAppendere );
        TweenMax.to('.img-daanimare-left', 1.6, {
            left: 0,
            ease: Power3.easeInOut,
            onComplete: () => {
                $('.img-burger-appesa').toggleClass('img-daanimare-left img-animata-left');
            }
        });
        TweenMax.to($classeDaRimuovere, 1.2, {
            left: '70vw',
            ease: Power3.easeInOut,
            delay: 0.2,
            onComplete: () => {
                $classeDaRimuovere.remove();
                $('#prev-slider-burger').css('pointer-events', 'auto');
            }
        });

        let hamburger = hamburgers[this.currentIndex];
        hamburger.corrente--;
        if( hamburger.corrente < 0 ){
            hamburger.corrente = hamburger.immagini.length - 1;
            let urlImgLast = 'url' + '(' + hamburger.immagini[ hamburger.corrente ] + ')';
            $('.img-daanimare-left').css( 'background-image', urlImgLast);
        }
        let urlImgSel = 'url' + '(' + hamburger.immagini[ hamburger.corrente ] + ')';
        $('.img-daanimare-left').css( 'background-image', urlImgSel);

    }

    closeSlideshow(callback) {
        $('#next-slider-burger').off('mouseenter mouseleave click');
        $('#prev-slider-burger').off('mouseenter mouseleave click');

        this.tlZoomImageClose.eventCallback('onReverseComplete', () => {
            btnFade('#zoom-btn', 'in');
            btnFade('#about-btn', 'in');

            TweenMax.to($('#prev-slider-burger'), 1.2, {
                left: '-18vw',
                ease: Back.easeOut.config(1.7),
                y: 0
            });
            TweenMax.to($('#next-slider-burger'), 1.2, {
                right: '-18vw',
                ease: Back.easeOut.config(1.7),
                y: 0,
                delay: 1.2
            });
            callback.play();
        });
        this.tlZoomImageClose.reverse();

    }

    animationButtonZoom() {

        $('#zoom-btn').hover(function () {
            TweenMax.to('#zoom-btn', 0.4, { scale: 1.2, ease: Power3.easeInOut });
        }, function () {
            TweenMax.to('#zoom-btn', 0.4, { scale: 1, ease: Power3.easeInOut });
        });


        $('.close-img-zoom').hover(() => {
            const line1close = $('.close-img-zoom').find('.line-top-close');
            const line2close = $('.close-img-zoom').find('.line-bottom-close');
            const line3close = $('.close-img-zoom').find('.line-rtop-close');
            const line4close = $('.close-img-zoom').find('.line-rbottom-close');

            this.tlCloseB2.to(line1close, 0.3, {
                width: '54px',
                ease: Power3.easeInOut
            }, 0.4).to(line2close, 0.3, {
                width: '54px',
                ease: Power3.easeInOut
            }, 0.3).to(line3close, 0.3, {
                width: 0,
                ease: Power3.easeInOut
            }, 0.2).to(line4close, 0.3, {
                width: 0,
                ease: Power3.easeInOut
            }, 0.1);

            this.tlCloseB2.play();
        },() => {
            this.tlCloseB2.reverse();
        });

        $('#close-hamburger').hover(() => {

            this.tlCloseB.to($('.line-top-close'), 0.3, {
                width: '54px',
                ease: Power3.easeInOut
            }, 0.4).to($('.line-bottom-close'), 0.3, {
                width: '54px',
                ease: Power3.easeInOut
            }, 0.3).to($('.line-rtop-close'), 0.3, {
                width: 0,
                ease: Power3.easeInOut
            }, 0.2).to($('.line-rbottom-close'), 0.3, {
                width: 0,
                ease: Power3.easeInOut
            }, 0.1);

            this.tlCloseB.play();
        },() => {
            this.tlCloseB.reverse();
        });

    }
}

export default Slideshow;



/** WEBPACK FOOTER **
 ** ./components/slideshow.js
 **/